import './AdminSvc';
import './AnimatronPreviewsSvc';
import './AnimatronProjectsSvc';
import './AnimatronUsersSvc';
import './ExceptionHandler';
import './PlayerSvc';
import './ProjectModalSvc';
import './TagsSvc';
import './PaymentHelpers';
import './AuthenticationSvc';
import './LocalStorageSvc';
import './UserChangeWatcherSvc';
import './BackendSvc';
import './HttpSvc';
import './ProjectAugmenter';
import './EventSvc';
import './NewsSvc';
import './OAuthCallbackSvc';
// import './upgradeOneProjectSvc';
import './TranslateSvc';
import './MyFollowings';
import './AdSvc';
import './ViewPortSvc';
import './HttpProjectSvc';
import './AnalyticSvc';
import './StopPlaySvc';
import './AffiliateSvc';
import './WistiaSvc';
import './landingTemplateSvc';
import './videoFolderSvc';
import './userProjectCount';



// WEBPACK FOOTER //
// ./app/assets/javascripts/services/index.ts